/** Mirrors the backend `BRSPermission` enum (BluRedSelect.Common.Api). */
export const BrsPermission = {
  CanViewProjects: 'CanViewProjects',
  CanCreateProjects: 'CanCreateProjects',
  CanEditProjects: 'CanEditProjects',
  CanDeleteProjects: 'CanDeleteProjects',
  CanViewProducts: 'CanViewProducts',
  CanCreateProducts: 'CanCreateProducts',
  CanEditProducts: 'CanEditProducts',
  CanDeleteProducts: 'CanDeleteProducts',
  CanManageUserPermissions: 'CanManageUserPermissions',
  CanManageData: 'CanManageData',
  CanAdministerSystem: 'CanAdministerSystem',
} as const;

export type BrsPermission = (typeof BrsPermission)[keyof typeof BrsPermission];

export const PERMISSION_DENIED_TOOLTIP = 'You do not have the permissions to perform this action';

/** Mirrors the backend `BRSGrant` enum (BluRedSelect.Common.Api). */
export const BrsGrant = {
  CanViewOrgProjects: 'CanViewOrgProjects',
  CanManageUserProjects: 'CanManageUserProjects',
  CanReviewQuotesOfOrg: 'CanReviewQuotesOfOrg',
  CanAdministerOrganization: 'CanAdministerOrganization',
} as const;

export type BrsGrant = (typeof BrsGrant)[keyof typeof BrsGrant];

/** The `permissions` claim of the permission token (backend `UserAccess`). */
export interface UserAccess {
  permissions: string[];
  grants: Record<string, string[]>;
  organizationId?: string | null;
  isOwner?: boolean;
}

export interface PermissionTokenPayload {
  sub?: string;
  exp?: number;
  jti_gea?: string;
  permissions?: Partial<UserAccess>;
}

export interface PermissionTokenResponse {
  token: string;
}
